function addToCart(e) { 
  e.preventDefault(); 
  e.stopPropagation(); 
  window.add_to_cart(e);
}

function quantityAction(e) {
  e.preventDefault();
  window.quantityAction(e);
}

// Madison: antes decía e.preventdefault() (con minúscula), daba error y la cantidad escrita a mano no se actualizaba
function inputChange(e) {
  e.preventDefault();
  window.inputChange(e);
}

function inputFocus(e) {
  e.stopPropagation();
}

// Madison: logo de Madison al lado del precio, en 180 px (se muestra a 32–40 px en el celular); antes 512 px
var MADISON_LOGO = '//madisoncenter.com/cdn/shop/t/45/assets/logo-max-center_180x.png?v=38020612259249841541746280391';

// Madison: textos de la búsqueda SIEMPRE en español (en teléfonos configurados en inglés salían en inglés)
// y "1 - 4 de 4 resultados" (la traducción de Algolia decía "sin").
// Algolia carga sus textos DESPUÉS del aviso "initialize", por eso se aplican justo antes de armar la búsqueda.
var MADISON_TEXTOS_ES = {
  addToCart: 'Agregar',
  allProducts: 'Ver todos los productos',
  articles: 'Artículos',
  by: 'por',
  changeInput: 'cambiando tu búsqueda',
  clear: 'Borrar',
  clearAll: 'Restablecer',
  clearFilters: 'restableciendo filtros',
  close: 'Cerrar búsqueda',
  collections: 'Colecciones',
  in: 'en',
  matching: 'concuerdan',
  noResultFor: 'No hay resultados para',
  noResultFound: 'No se encontraron resultados',
  oneResultFound: '1 resultado encontrado',
  or: 'o',
  outOf: 'de',
  outOfStock: 'Agotado',
  pages: 'Páginas',
  products: 'Productos',
  relevance: 'Relevancia',
  resultsFound: 'resultados encontrados',
  search: 'Búsqueda actual',
  searchForProduct: 'Búsqueda de productos',
  searchTitle: 'Resultado de búsqueda',
  selectedFilter: 'Filtros seleccionados',
  showLess: 'Ocultar',
  showMore: 'Mostrar más',
  showFilters: 'Mostrar filtros',
  sortBy: 'Ordenado por',
  suggestions: 'Sugerencias',
  taxFree: 'Libre de impuesto',
  try: 'Intentar'
};

function madisonEspanol() {
  if (window.algoliaShopify && algoliaShopify.translations) Object.assign(algoliaShopify.translations, MADISON_TEXTOS_ES);
}

// Madison: ¿el producto se puede pedir? En los resultados Algolia lo envía calculado (can_order); en el panel de
// sugerencias no, así que se calcula igual: hay inventario o la tienda deja vender sin inventario.
function madisonSePuedePedir(producto) {
  if (producto.can_order !== undefined) return producto.can_order;
  return producto.inventory_available === true || producto.inventory_policy === 'continue';
}

// Madison: etiqueta "Entrega en 90 min" (la misma de las demás tarjetas); si el producto no se puede pedir, el espacio queda vacío
function madisonEntrega(html, sePuedePedir) {
  return sePuedePedir
    ? html`<div class="madison-entrega" style="display: flex; width: fit-content; align-items: center; gap: 2px; margin: 8px auto 0; padding: 1px 4px; border-radius: 3px; background: #2A3378; color: #FFFFFF; font-size: 9px; line-height: 1.2; font-weight: 400; white-space: nowrap;"><svg width="7" height="9" viewBox="0 0 11 13" aria-hidden="true" focusable="false" style="flex-shrink: 0;"><path d="M6.6 0 0.8 7.3h3.9L3.9 13l6.3-7.6H6.2L6.6 0z" fill="#FDC441"/></svg><span>Entrega en <strong style="font-weight: 800;">90 min</strong></span></div>`
    : html`<div class="madison-entrega" aria-hidden="true" style="visibility: hidden; margin: 8px auto 0; height: 13px;"></div>`;
}

document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function(options) {
    madisonEspanol();
    return options;
  });
});

document.addEventListener('algolia.hooks.initialize', function() {
   algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    madisonEspanol();
    // Change the placeholder text of the autocomplete menu
    options.placeholder = "¿Qué desearías buscar hoy?";
    // Madison: no abrir resultados con el buscador vacío (salía 'No hay resultados' al tocarlo)
    options.openOnFocus = false;
    // Madison: no mostrar resultados mientras se escribe (pedido de Jonathan 2026-10-03). Solo al tocar la lupa o "buscar"
    // del teclado, que lleva a la página de resultados (/search). Sin fuentes = sin lista y sin consultas a Algolia al escribir.
    options.getSources = function () { return []; };
    // Madison: en el celular se escribe en el buscador de la barra de arriba y los resultados salen debajo, sin abrir
    // otra ventana de búsqueda (pedido de Jonathan 2026-10-03). 'none' = nunca usar el modo "ventana aparte".
    options.detachedMediaQuery = 'none';
    // Madison: botones del panel de sugerencias en español (en teléfonos en inglés decía "Cancel")
    options.translations = Object.assign({}, options.translations, {
      detachedCancelButtonText: 'Cancelar',
      clearButtonTitle: 'Borrar',
      submitButtonTitle: 'Buscar',
      detachedSearchButtonTitle: 'Buscar'
    });
    return options;
  });
  
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    madisonEspanol();
    return html`
      <div class="ais-page">
        <h1 class="ais-h2" style="display: none">${algoliaShopify.translations.searchTitle}</h1>
        <div class="ais-input" style="display: none">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          ${algoliaShopify.translations.showFilters}
        </div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
            facet =>
              html`
                <div
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                >
                  <label
                    for="${facet.escapedName}"
                    class="ais-range-slider--header ais-facet--header ais-header"
                    >${facet.title}</label
                  >
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
          )}
        </div>
        <!-- Madison: cabecera igual a la de las categorías (pedido de Jonathan 2026-10-03): lo buscado y "N productos";
             debajo, entre dos líneas grises, "Ordenar por" a la izquierda y las vistas lista / cuadrícula a la derecha.
             madison-carrito.js pone el título y la cantidad. -->
        <div class="madison-busqueda__cabecera">
          <h1 class="madison-busqueda__titulo"></h1>
          <p class="madison-busqueda__cuenta"></p>
        </div>
        <div class="ais-block">
          <div class="ais-search-header madison-busqueda__barra">
            <div class="ais-stats-container"></div>
            <div class="ais-sort madison-busqueda__orden">
              <span class="madison-busqueda__orden-texto">Ordenar por</span>
              <svg class="madison-busqueda__flecha" viewBox="0 0 12 8" width="12" height="8" aria-hidden="true"><path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path></svg>
              ${data.multipleSortOrders
                ? html`<span class="ais-sort-orders-container"></span>`
                : ''}
            </div>
            <!-- Vistas como en la app: botones con borde redondeado; el elegido en azul con el ícono blanco -->
            <div class="ais-change-display madison-busqueda__vistas">
              <span class="ais-change-display-block ais-change-display-selected" role="button" aria-pressed="true" aria-label="Mostrar productos como cuadrícula"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><rect x="3" y="3" width="8" height="8" rx="2"/><rect x="13" y="3" width="8" height="8" rx="2"/><rect x="3" y="13" width="8" height="8" rx="2"/><rect x="13" y="13" width="8" height="8" rx="2"/></svg></span>
              <span class="ais-change-display-list" role="button" aria-pressed="false" aria-label="Mostrar productos como lista"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><circle cx="4.5" cy="6" r="1.6"/><circle cx="4.5" cy="12" r="1.6"/><circle cx="4.5" cy="18" r="1.6"/><rect x="8.5" y="5" width="12.5" height="2" rx="1"/><rect x="8.5" y="11" width="12.5" height="2" rx="1"/><rect x="8.5" y="17" width="12.5" height="2" rx="1"/></svg></span>
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });
});

document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components, trackSearchAttribution) {
    madisonEspanol();
    const hitImage = algoliaShopify.helpers.renderImage(hit, 250);
    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => trackSearchAttribution(hit)}"
      >
      ${hit.compare_at_price != '' &&
        html`
            <div class="product-item__label-list">
            <span class="product-label product-label--on-sale">${algoliaShopify.helpers.displayDiscount(
                    hit.price,
                    hit.compare_at_price,
                    hit.price_ratio
                  )} OFF</span></div>
        `} 
        <img
          class="ais-hit--picture"
          src="${hitImage.src}"
          srcset="${hitImage.srcset}"
          sizes="${hitImage.sizes}"
          alt="${hit.title} - ${hit.variant_title}"
        />

        <div class="ais-hit--details">
        <div class="text-container">
          <p class="ais-hit--title product-item__title text--strong link">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>
          <p style="display: none"
            class="ais-hit--subtitle"
            title="${hit.product_type}${algoliaShopify.translation_helpers.by(
              hit.vendor
            )}"
          >
            ${components.Highlight({ attribute: 'product_type', hit })}
            ${hit.vendor &&
              html`
                <span> ${algoliaShopify.translations.by} </span>
              `}
            ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
          </p>
          <!-- Madison: div (no p) para que el precio quede al lado del logo: un p no puede contener un div -->
          <div class="ais-hit--price product-item__price-list price-list">
            <img src="${MADISON_LOGO}" alt="" />
            <div class="price-container"><b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
           
            <span class="ais-hit--price-striked"
              ><span
                >${algoliaShopify.helpers.displayStrikedPrice(
                  hit.price,
                  hit.compare_at_price
                )}</span
              ></span></div>
             
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-discount"
                  >${algoliaShopify.helpers.displayDiscount(
                    hit.price,
                    hit.compare_at_price,
                    hit.price_ratio
                  )}</span
                >
              `}
          </div>
          ${madisonEntrega(html, madisonSePuedePedir(hit))}
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${hit.sku &&
              html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'sku', hit })}</span
                >
              `}
            ${hit.barcode &&
              html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
              html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
              html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult.tags?.map(
              tag =>
                html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
            )}
          </p>
          </div>
          ${(!hit._distinct || hit.variants_count <= 1) ?
            html`
                <p class="ais-hit--cart">
                  ${hit.can_order
                    ? html`
                      <form
                          id="algolia-add-to-cart-${hit.objectID}"
                          action="/cart/add"
                          method="post"
                          enctype="multipart/form-data"
                        >
                          <input type="hidden" name="id" value="${hit.objectID}" />
                        <div class="product-item__add-to-cart">
                          <button
                            class="ais-hit--cart-button"
                            data-form-id="algolia-add-to-cart-${hit.objectID}"
                            onClick="${(e) => addToCart(e)}"
                          >
                            ${algoliaShopify.translations.addToCart}
                          </button>
                        <div class="product-item__quantity-selector product-item__action-button button d-none button--small button--primary" 
                          data-product-image="${hitImage.src}" 
                          data-product-title="${hit.title}"
                        >
                          <div class="product-item__quantity-selector--minus product-item__quantity-selector--action" onClick="${(e) => quantityAction(e)}">
                            -
                          </div>
                          <input type="text" name="quantity_selector" class="product-item__quantity-selector--input" data-value="1" value="1" min="1" onFocus="${(e) => inputFocus(e)}" onChange="${(e) => inputChange(e)}" />
                          <div class="product-item__quantity-selector--plus product-item__quantity-selector--action" onClick="${(e) => quantityAction(e)}">+</div>
                        </div>
                      </div>
                      </form>
                      `
                    : html`
                        <button
                          class="ais-hit--cart-button ais-hit--cart-button__disabled"
                        >
                          ${algoliaShopify.translations.outOfStock}
                        </button>
                      `}
                </p>
                `
            : html`
              <button
                class="ais-hit--cart-button "
              >
                <span>Escoger opciones</span>
              </button>
            `}
        </div>
      </div>
    `;
  });
});

document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      // Modify default options, then return them

      const { html, item, components } = templateOptions;
      // Madison: foto de 250 px directamente (antes se pedía la de 125 px, se veía borrosa y madison.js la cambiaba: se bajaban las dos)
      const foto = algoliaShopify.helpers.renderImage(item, 250);
      return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${() => trackSearchAttribution(item)}">
      <div class="aa-ItemContent">
        ${item.compare_at_price != '' &&
          html`
            <div class="product-item__label-list">
            <span class="product-label product-label--on-sale">${algoliaShopify.helpers.displayDiscount(
                    item.price,
                    item.compare_at_price,
                    item.price_ratio
                  )} OFF</span></div>
        `} 
      
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${foto.src}"
            srcset="${foto.srcset}"
            sizes="${foto.sizes}"
            alt="${item.title}" />
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentBrand">
            ${
              item.product_type &&
              components.Highlight({ hit: item, attribute: "product_type" })
            }
          </div>
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
          </div>
          <div class="aa-ItemContentPrice product-item__price-list price-list">
            <img src="${MADISON_LOGO}" alt="" />
            <div class="aa-ItemContentPriceCurrent">
              ${algoliaShopify.helpers.displayPrice(item, distinct)}
              <span class="ais-hit--price-striked"><s>${algoliaShopify.helpers.displayStrikedPrice(item.price, item.compare_at_price)}</s></span>
            </div>
          </div>
          ${madisonEntrega(html, madisonSePuedePedir(item))}

          <form
              id="algolia-add-to-cart-${item.objectID}"
              action="/cart/add"
              method="post"
              enctype="multipart/form-data"
            >
            <input type="hidden" name="id" value="${item.objectID}" />
            <div class="product-item__add-to-cart">
              
              <button
                class="ais-hit--cart-button"
                data-form-id="algolia-add-to-cart-${item.objectID}"
                onClick="${(e) => addToCart(e)}"
              >
                ${algoliaShopify.translations.addToCart}
              </button>
              <div class="product-item__quantity-selector product-item__action-button button d-none button--small button--primary" 
                data-product-image="${foto.src}" 
                data-product-title="${item.title}"
              >
                <div class="product-item__quantity-selector--minus product-item__quantity-selector--action" onClick="${(e) => quantityAction(e)}">
                  -
                </div>
                <input type="text" name="quantity_selector" class="product-item__quantity-selector--input" data-value="1" value="1" min="1" onFocus="${(e) => inputFocus(e)}" onChange="${(e) => inputChange(e)}" />
                <div class="product-item__quantity-selector--plus product-item__quantity-selector--action" onClick="${(e) => quantityAction(e)}">+</div>
              </div>
          </div>
        </form>
        </div>
      </div>
    </a>
  `;
    }
  );
});
